module.exports = __webpack_public_path__ + "img/home.f2c66b83.svg";